import { put2 } from "@/shared/axios";
import usePaymentLedgerHook from "@/shared/hooks/usePaymentLedgerHook";
import {
  AppsmenError,
  PaymentLedger,
  PaymentLedgerPaymentBody,
} from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";

interface PaymentLedgerPaymentPut extends PaymentLedgerPaymentBody {
  paymentLedgerId: number;
  paymentMethodId: number;
  isSession: number;
}

const usePaymentLedgerPaymentPut = () => {
  const { refetch } = usePaymentLedgerHook(false);

  const mutation = useMutation<
    PaymentLedger,
    AppsmenError,
    PaymentLedgerPaymentPut
  >({
    mutationFn: ({ paymentLedgerId, paymentMethodId, isSession, ...body }) =>
      put2(
        `internal/secure/pos/v1/orders/payment-ledger-payment/${isSession}/${paymentLedgerId}/${paymentMethodId}`,
        body
      ),
    onSuccess: () => {
      refetch();
    },
  });

  return mutation;
};

export default usePaymentLedgerPaymentPut;
